/**
 * Given URL search param in a form of a string or an array of strings,
 * normalizes them to an array of strings.
 *
 * @example1 [] => undefined
 * @example2 ['tag1', 'tag2'] => ['tag1', 'tag2']
 * @example3 (value is not string) => undefined
 * @example4 'tag1,tag2' => ['tag1', 'tag2']
 */
export const normalizeArraySearchParam = (tags?: string | string[]) => {
  if (Array.isArray(tags)) {
    if (tags.length === 0) {
      return undefined
    }

    return tags
  }

  if (typeof tags !== 'string') {
    return undefined
  }

  return tags.split(',')
}
